// Panel admin: bandeja de despacho MercadoLibre
// SEPARADO de /admin/entregas (Limpack propio suscripciones + tienda).
// Lee de ml_ventas (status paid/shipped) y clasifica por shipping_status:
// ready_to_ship/handling/pending = pendiente · shipped = en tránsito · delivered = entregada.
// Agrupa por shipping_mode (Flex Colecta / Flex Places / Standard / Full).

import { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../../lib/supabase'
import AdminLayout from '../../components/AdminLayout'

// Imprime una imagen de etiqueta a 100x150mm (XPrinter térmica) vía iframe oculto.
function imprimirEtiquetaImg(src, titulo = 'Etiqueta') {
  const prev = document.getElementById('et-print-frame')
  if (prev) prev.remove()
  const iframe = document.createElement('iframe')
  iframe.id = 'et-print-frame'
  iframe.setAttribute('aria-hidden', 'true')
  Object.assign(iframe.style, { position: 'fixed', right: '0', bottom: '0', width: '0', height: '0', border: '0' })
  document.body.appendChild(iframe)
  const doc = iframe.contentWindow.document
  doc.open()
  doc.write(
    '<!doctype html><html><head><meta charset="utf-8"><title>' + titulo + '</title><style>'
    + '@page{size:100mm 150mm;margin:0}'
    + 'html,body{margin:0;padding:0;width:100mm;height:150mm;overflow:hidden}'
    + 'img{width:100mm;height:150mm;display:block;object-fit:contain}'
    + '</style></head><body><img src="' + src + '"></body></html>'
  )
  doc.close()
  const img = doc.querySelector('img')
  const go = () => { try { iframe.contentWindow.focus(); iframe.contentWindow.print() } catch (e) {} }
  if (img && !img.complete) { img.onload = () => setTimeout(go, 80); img.onerror = go }
  else { setTimeout(go, 150) }
}

// Etiquetas genéricas Limpack para pegar en las cajas (térmica 100x150mm).
function EtiquetasParaPegar() {
  const items = [
    { key: 'fragil', emoji: '📦', titulo: 'Frágil', desc: 'FRÁGIL + "este lado arriba". B/N, 100×150mm.',
      png: '/materiales-ml/etiqueta-fragil-termica.png', pdf: '/materiales-ml/etiqueta-fragil-termica-100x150.pdf' },
    { key: 'gracias', emoji: '💙', titulo: 'Gracias', desc: 'Agradecimiento Limpack. 100×150mm.',
      png: '/materiales-ml/etiqueta-gracias-termica.png', pdf: '/materiales-ml/etiqueta-gracias-termica-100x150.pdf' },
  ]
  return (
    <div className="card" style={{ marginTop: 16, borderLeft: '4px solid #00A8B5' }}>
      <h3 style={{ margin: '0 0 2px' }}>🏷️ Etiquetas para pegar</h3>
      <div className="desc" style={{ marginBottom: 12 }}>Genéricas Limpack (Frágil / Gracias) — se imprimen en la XPrinter térmica 100×150mm.</div>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        {items.map(it => (
          <div key={it.key} style={{ display: 'flex', alignItems: 'center', gap: 12, border: '1px solid #E2E8F0', borderRadius: 12, padding: 12, flex: '1 1 320px', minWidth: 280 }}>
            <img src={it.png} alt={`Etiqueta ${it.titulo} Limpack`} style={{ width: 54, height: 80, objectFit: 'contain', border: '1px solid #EDF1F6', borderRadius: 6, background: '#fff', flex: 'none' }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 800, color: '#1A3461', fontSize: 14 }}>{it.emoji} Etiqueta {it.titulo}</div>
              <div style={{ fontSize: 12, color: '#64748B', margin: '2px 0 8px' }}>{it.desc}</div>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <button className="btn" style={{ background: '#00A8B5', border: '1px solid #00A8B5', color: '#fff', borderRadius: 8, padding: '6px 12px', fontSize: 12.5, fontWeight: 700, cursor: 'pointer' }}
                  onClick={() => imprimirEtiquetaImg(it.png, `Etiqueta ${it.titulo}`)}>🖨 Imprimir</button>
                <a className="btn" style={{ border: '1px solid #E2E8F0', color: '#475569', borderRadius: 8, padding: '6px 12px', fontSize: 12.5, fontWeight: 700, textDecoration: 'none' }}
                  href={it.pdf} target="_blank" rel="noopener noreferrer">⭳ PDF</a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

// Config visual por modo de envío ML
const MODOS = {
  me2: {
    label: 'Flex Colecta',
    icono: '📦',
    color: '#10B981',
    ayuda: 'ML pasa a buscar el paquete por Limpack en el horario que configuraste.',
  },
  me1: {
    label: 'Flex Places',
    icono: '🚚',
    color: '#3B82F6',
    ayuda: 'Llevás el paquete a un punto Place (mini depósito ML cercano).',
  },
  custom: {
    label: 'Standard (agencia)',
    icono: '🏪',
    color: '#7C3AED',
    ayuda: 'Llevás el paquete a la agencia ML del barrio.',
  },
  fbm: {
    label: 'Full (ya en bodega ML)',
    icono: '🏭',
    color: '#94A3B8',
    ayuda: 'ML tiene stock. No hacés nada — solo monitor.',
  },
  not_specified: {
    label: 'A definir',
    icono: '❓',
    color: '#F59E0B',
    ayuda: 'ML todavía no confirmó modo. Esperá el próximo webhook.',
  },
}

function metaModo(m) {
  const raw = (m || '').toLowerCase()
  if (raw.includes('me2') || raw.includes('flex') && raw.includes('colecta')) return MODOS.me2
  if (raw.includes('me1') || raw.includes('places')) return MODOS.me1
  if (raw.includes('fbm') || raw.includes('full')) return MODOS.fbm
  if (raw.includes('custom') || raw.includes('estandar') || raw.includes('standard')) return MODOS.custom
  return MODOS[raw] || MODOS.not_specified
}

export default function DespachoML() {
  const [ventas, setVentas] = useState([])
  const [loading, setLoading] = useState(true)
  const [descargando, setDescargando] = useState({})
  const [marcandoListo, setMarcandoListo] = useState({})
  const [msg, setMsg] = useState(null)

  async function cargar() {
    // ml_ventas con status paid AND date_shipped null (pendientes de despacho)
    // + entregadas del día (para historial rápido)
    const desde = new Date()
    desde.setDate(desde.getDate() - 3); desde.setHours(0, 0, 0, 0)
    const { data } = await supabase.from('ml_ventas')
      .select('id, ml_order_id, ml_item_id, producto_id, cantidad, cliente_nickname, cliente_nombre, cliente_ciudad, monto_bruto, neto, status, shipping_id, shipping_mode, shipping_status, shipping_tracking, date_paid, date_shipped, date_delivered')
      .in('status', ['paid', 'shipped'])
      .gte('date_paid', desde.toISOString())
      .order('date_paid', { ascending: false })
      .limit(200)
    setVentas(data || [])
    setLoading(false)
  }

  useEffect(() => {
    cargar()
    const t = setInterval(cargar, 60000)
    return () => clearInterval(t)
  }, [])

  async function descargarEtiqueta(venta) {
    if (!venta.shipping_id) return alert('Sin shipping_id — ML todavía no asignó envío.')
    setDescargando({ ...descargando, [venta.id]: true })
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const url = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/ml-descargar-etiqueta`
      const resp = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${session?.access_token || ''}`,
          'apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ shipping_id: venta.shipping_id }),
      })
      if (!resp.ok) {
        const data = await resp.json().catch(() => ({}))
        throw new Error(data?.error || 'HTTP ' + resp.status)
      }
      const blob = await resp.blob()
      const objectUrl = URL.createObjectURL(blob)
      window.open(objectUrl, '_blank')
    } catch (e) {
      alert('Error descargando etiqueta: ' + e.message)
    } finally {
      const { [venta.id]: _, ...rest } = descargando
      setDescargando(rest)
    }
  }

  async function marcarListo(venta) {
    // Marca localmente que Limpack ya preparó el paquete (aún no despachó — eso lo hace ML)
    if (!confirm(`¿Marcar preparado?\n\nOrder ${venta.ml_order_id} · ${venta.cliente_nickname || 'anónimo'}`)) return
    setMarcandoListo({ ...marcandoListo, [venta.id]: true })
    try {
      await supabase.from('ml_ventas').update({
        shipping_status: 'ready_to_ship',
        updated_at: new Date().toISOString(),
      }).eq('id', venta.id)
      cargar()
      setMsg({ ok: true, txt: `Order ${venta.ml_order_id} marcada como preparada.` })
    } catch (e) {
      setMsg({ ok: false, txt: e.message })
    } finally {
      const { [venta.id]: _, ...rest } = marcandoListo
      setMarcandoListo(rest)
    }
  }

  // Clasificación por shipping_status (fuente de verdad) en vez de date_shipped/date_delivered,
  // que no se setean bien (dejaban ventas viejas sin envío como "pendientes" y las entregadas como "en tránsito").
  const PRE_SHIP = ['ready_to_ship', 'handling', 'pending', 'ready_to_print']
  const pendientes = useMemo(() => ventas.filter(v =>
    v.status !== 'cancelled' &&
    (PRE_SHIP.includes(v.shipping_status) || (!v.shipping_status && v.shipping_id && !v.date_shipped))
  ), [ventas])
  const despachadas = useMemo(() => ventas.filter(v => v.shipping_status === 'shipped'), [ventas])
  const entregadas = useMemo(() => ventas.filter(v => v.shipping_status === 'delivered').slice(0, 20), [ventas])

  const grupos = useMemo(() => {
    const g = {}
    for (const v of pendientes) {
      const key = (v.shipping_mode || 'not_specified').toLowerCase()
      if (!g[key]) g[key] = []
      g[key].push(v)
    }
    return g
  }, [pendientes])

  const fmt = (n) => '$ ' + Number(n || 0).toLocaleString('es-UY', { maximumFractionDigits: 0 })
  const fmtDate = (s) => s ? new Date(s).toLocaleString('es-UY', { dateStyle: 'short', timeStyle: 'short' }) : '—'

  return (
    <AdminLayout>
      <div className="page">
        <Link to="/admin/canales/mercadolibre" style={{ fontSize: 13, color: 'var(--muted)' }}>← Volver a MercadoLibre</Link>

        <div style={{ marginTop: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12 }}>
          <div>
            <h1 style={{ margin: 0 }}>📦 Despacho MercadoLibre</h1>
            <p className="lead" style={{ margin: '4px 0 0' }}>
              Bandeja operativa de las ventas ML pendientes de despacho. <strong>No se mezcla con la ruta Limpack</strong> — cada venta ML usa Mercado Envíos.
            </p>
          </div>
        </div>

        {msg && (
          <div style={{
            marginTop: 12, padding: '10px 14px', borderRadius: 8,
            background: msg.ok ? '#DCFCE7' : '#FEE2E2',
            color: msg.ok ? '#166534' : '#7F1D1D',
            fontSize: 13, fontWeight: 600,
          }} onClick={() => setMsg(null)}>{msg.txt}</div>
        )}

        {/* KPIs */}
        <div className="cards-grid" style={{ marginTop: 16 }}>
          <div className="card" style={{ borderLeft: '4px solid #F59E0B' }}><h3>Pendientes despacho</h3><div className="stat" style={{ color: '#F59E0B' }}>{pendientes.length}</div><div className="desc">listas para despachar</div></div>
          <div className="card" style={{ borderLeft: '4px solid #3B82F6' }}><h3>En tránsito</h3><div className="stat" style={{ color: '#3B82F6' }}>{despachadas.length}</div><div className="desc">shipping = shipped</div></div>
          <div className="card" style={{ borderLeft: '4px solid #10B981' }}><h3>Entregadas</h3><div className="stat" style={{ color: '#10B981' }}>{entregadas.length}</div><div className="desc">últimas 20</div></div>
        </div>

        <EtiquetasParaPegar />

        {loading ? (
          <div className="card" style={{ marginTop: 16, color: 'var(--muted)' }}>Cargando…</div>
        ) : pendientes.length === 0 ? (
          <div className="card" style={{ marginTop: 16, color: 'var(--muted)', textAlign: 'center', padding: 32 }}>
            <div style={{ fontSize: 40, opacity: 0.4 }}>📦</div>
            <p style={{ margin: '10px 0 4px' }}>Nada pendiente de despacho.</p>
            <p style={{ margin: 0, fontSize: 11, color: '#94A3B8' }}>Cuando entre una venta ML nueva vas a verla acá.</p>
          </div>
        ) : (
          <>
            {/* Grupos por modo de envío */}
            {Object.entries(grupos).map(([modo, items]) => {
              const meta = metaModo(modo)
              return (
                <div key={modo} style={{ marginTop: 20 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                    <span style={{ fontSize: 22 }}>{meta.icono}</span>
                    <h2 style={{ margin: 0, fontSize: 16, color: '#1A3461' }}>{meta.label}</h2>
                    <span style={{
                      background: meta.color, color: '#fff', padding: '2px 10px',
                      borderRadius: 999, fontSize: 12, fontWeight: 800,
                    }}>{items.length}</span>
                  </div>
                  <p style={{ margin: '0 0 12px', fontSize: 12, color: '#64748B' }}>{meta.ayuda}</p>

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 8 }}>
                    {items.map(v => (
                      <div key={v.id} style={{
                        background: '#fff', border: '1px solid #E2E8F0',
                        borderLeft: `4px solid ${meta.color}`,
                        borderRadius: 10, padding: 14,
                        display: 'grid', gridTemplateColumns: '1fr auto', gap: 14, alignItems: 'center',
                      }}>
                        <div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4, flexWrap: 'wrap' }}>
                            <code style={{ fontSize: 11, background: '#F8FAFC', padding: '2px 8px', borderRadius: 4, color: '#475569' }}>{v.ml_order_id}</code>
                            <strong style={{ fontSize: 13, color: '#1A3461' }}>@{v.cliente_nickname || 'anónimo'}</strong>
                            {v.cliente_ciudad && <span style={{ fontSize: 11, color: '#64748B' }}>📍 {v.cliente_ciudad}</span>}
                            <span style={{ fontSize: 11, color: '#64748B' }}>×{v.cantidad}</span>
                          </div>
                          <div style={{ fontSize: 12, color: '#475569' }}>
                            Pagado {fmtDate(v.date_paid)} · Neto Limpack <strong style={{ color: '#10B981' }}>{fmt(v.neto)}</strong>
                            {v.shipping_status && <> · Envío: <strong>{v.shipping_status}</strong></>}
                            {v.shipping_tracking && <> · Tracking: <code style={{ fontSize: 10 }}>{v.shipping_tracking}</code></>}
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                          {v.producto_id && (
                            <Link to={`/admin/stock/${v.producto_id}`} style={{
                              padding: '6px 10px', border: '1px solid #CBD5E1', background: '#fff',
                              borderRadius: 6, textDecoration: 'none', fontSize: 12, color: '#475569',
                            }}>Ficha</Link>
                          )}
                          {v.shipping_id && (
                            <button
                              onClick={() => descargarEtiqueta(v)}
                              disabled={!!descargando[v.id]}
                              style={{
                                padding: '6px 12px', border: 'none',
                                background: '#3B82F6', color: '#fff',
                                borderRadius: 6, fontSize: 12, fontWeight: 700,
                                cursor: descargando[v.id] ? 'wait' : 'pointer',
                              }}
                            >
                              {descargando[v.id] ? 'Bajando…' : '📄 Etiqueta'}
                            </button>
                          )}
                          {v.shipping_status !== 'ready_to_ship' && (
                            <button
                              onClick={() => marcarListo(v)}
                              disabled={!!marcandoListo[v.id]}
                              style={{
                                padding: '6px 12px', border: 'none',
                                background: '#10B981', color: '#fff',
                                borderRadius: 6, fontSize: 12, fontWeight: 700,
                                cursor: marcandoListo[v.id] ? 'wait' : 'pointer',
                              }}
                            >
                              ✓ Preparado
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )
            })}

            {/* En tránsito */}
            {despachadas.length > 0 && (
              <div style={{ marginTop: 28 }}>
                <h2 style={{ margin: '0 0 10px', fontSize: 16, color: '#1A3461' }}>🚚 En tránsito ({despachadas.length})</h2>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 6 }}>
                  {despachadas.map(v => (
                    <div key={v.id} style={{
                      background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: 8,
                      padding: '10px 14px', fontSize: 12, color: '#475569',
                      display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap',
                    }}>
                      <code style={{ fontSize: 10, background: '#fff', padding: '1px 6px', borderRadius: 3 }}>{v.ml_order_id}</code>
                      <strong style={{ color: '#1A3461' }}>@{v.cliente_nickname}</strong>
                      {v.date_shipped && <span>Despachado {fmtDate(v.date_shipped)}</span>}
                      {v.shipping_tracking && <span>· Tracking <code>{v.shipping_tracking}</code></span>}
                      <span style={{ marginLeft: 'auto', fontSize: 11, color: '#3B82F6', fontWeight: 700 }}>{v.shipping_status}</span>
                      {v.shipping_id && (
                        <button
                          onClick={() => descargarEtiqueta(v)}
                          disabled={!!descargando[v.id]}
                          title="Reimprimir etiqueta de envío"
                          style={{ padding: '4px 10px', border: '1px solid #CBD5E1', background: '#fff', color: '#1A3461', borderRadius: 6, fontSize: 11.5, fontWeight: 700, cursor: descargando[v.id] ? 'wait' : 'pointer' }}>
                          {descargando[v.id] ? 'Bajando…' : '📄 Etiqueta'}
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </AdminLayout>
  )
}
